import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CustomizedDialogs from "./CustomDialog";


export default function ConfirmDialog(props) {
    const classes = useStyles()
    const [open, setOpen] = useState(false)
    useEffect(() => {
        setOpen(props.open)
    }, [props.open])
    
    return (
        <CustomizedDialogs
            key={Math.random()}
            open={open}
            title={props.title}
            content={
                <React.Fragment>
                    <Typography gutterBottom className={classes.text}>
                        기존 검진한 내용이 있습니다
                    </Typography>
                   
                    <Typography gutterBottom className={classes.text}>
                        기존 검진을 삭제하고 시작하시겠습니까?
                    </Typography>
                </React.Fragment>
            }
      
            submit={async () => {
                setOpen(false)
                if(props.onOK){
                    props.onOK()
                }
            }}
            close={() => {
               if(props.onCancel){
                   props.onCancel()
               }
            }}
            buttonName={'확인'}
        />
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 800,
        margin: 'auto',

        '& .item': {
            padding : '20px 10px'
        }
    },
    back: {
        marginTop: 30,
        '&:hover': {
            backgroundColor: '#053288',
        }
    },
    small: {
        fontSize: 14,
        color: '#999',
    },
    remove: {
        color: '#ccc',
        '&:hover': {
            color: '#666'
        },
        marginLeft: 20
    },
    date: {
        fontSize: 14,
        color: '#999',
        fontFamily: 'Noto Sans KR',
    },
    text:{
        fontFamily: 'Noto Sans KR',
    },
    inline: {
        display: 'inline',
    },
    listRoot: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
}));
